
export function devisReducer(state = {
    "PLAN_VISIT":[],
    "WAITING_VISIT":[],
    "WAITING_QUOTATION":[],
    "WAITING_VALIDATION":[],
    "WAITING_ANSWER":[],
    "VALIDATE":[],
    "REFUSED":[],
    "INSTALLED":[],
},{
    type,
    payload
}){
    
    switch(type){
        case "NEW_ACTION":   
            let list = Object.assign({},state)  
            let last = payload.lastStatus       
            let next = payload.newAction.nextStatus     
            let ID = payload.newAction.client_id
            if( next !== "NO_CHANGE"){
                list[last] = list[last].filter( value => {
                    return value !== ID;            
                });
                list[next].push(ID)

            }
            return list;

        case "GET_ALL_DEVIS":
            let list2 = Object.assign({},state)
            list2[payload.type] = payload.idList
            return list2;

        case "ASK_DEVIS_ADD":
            // list = state
            // list.PLAN_VISIT[payload.ID] = payload
            // return {[payload.ID] : payload, ...state};
            return state;
        
        default:
            return state;
    }
    
}
